import { Box } from 'reflexbox';

import { Container } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import UserDocuments from 'packages/kakapo-ui-application/pages/users/UserDocuments';
import UserDownloads from 'packages/kakapo-ui-application/pages/users/UserDownloads';

export default function PersonalFiles(props: { userID: string }) {
	const query = graphql.useUserQuery({ variables: { id: props.userID } });

	if (!query.data) {
		return null;
	}

	return (
		<Container px={5} py={5}>
			<Box mb={5}>
				<UserDocuments user={query.data.user as graphql.User} />
			</Box>
			<Box>
				<UserDownloads user={query.data.user as graphql.User} />
			</Box>
		</Container>
	);
}
